import { useMemo } from 'react'
import { useGetInvoiceTotals } from '@cocoonspace/sdk-js/domains/invoices/invoices'
import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'
import { Card } from '@cocoonspace/ui/components/card'
import { Trans } from '@lingui/react/macro'
import { keepPreviousData } from '@tanstack/react-query'

import { useFormatPrice } from '~/hooks/use-format-price'
import { useInvoicesFilters } from './use-invoices-filters.hook'

export const YearRecap = () => {
	const formatPrice = useFormatPrice()
	const [filters] = useInvoicesFilters()

	const { data: invoicesTotal } = useGetInvoiceTotals(
		{ year: filters.activeYear },
		{ query: { placeholderData: keepPreviousData } },
	)

	const relativetoYear = useMemo(
		() =>
			filters.activeYear && filters.activeYear === dateTimeUtils().year()
				? dateTimeUtils().customFormat('date')
				: dateTimeUtils(`${filters.activeYear}-12-31`).customFormat('date'),
		[filters.activeYear],
	)

	return (
		<Card className='mr-auto flex items-center p-4'>
			<div className='inline-flex flex-row items-center text-2xl'>
				<div className='bg-primary mr-4 h-[66px] w-[8px] rounded' />

				<div className='flex flex-col justify-center gap-1 leading-none'>
					<div className='flex flex-row items-end gap-1'>
						<span className='leading-none font-bold'>
							<Trans>Total cumulé {filters.activeYear}</Trans>
						</span>

						<span className='text-xs'>
							<Trans>au {relativetoYear}</Trans>
						</span>
					</div>

					<span className='flex items-baseline gap-1'>
						<span className='font-bold'>
							{formatPrice(invoicesTotal?.data.total ?? 0, 'EUR')}
						</span>

						<span className='text-xxs'>HT</span>
					</span>
				</div>
			</div>
		</Card>
	)
}
